/* eslint-disable no-magic-numbers */
export const httpStatusCodes = {
    ok: 200,
    noContent: 204,
    resetContent: 205,
    multipleChoices: 300,
};
/* eslint-enable no-magic-numbers */
